.map-legend {
  background-color: var(--color-bg-primary);
  color: var(--color-text-primary);
  padding: 5px 0;
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  & svg {
    width: 100%;
    height: 100%;
  }


  & svg path:nth-child(1){
    stroke: var(--color-border-accent);
  }
  // ticks are always before a text, otherwise hard to identify (the legend gradient is build with path so we can not overwrite all)
  svg path:has(+ text) {
    stroke: var(--color-border-accent);
  }
  & svg text {
    font-weight: 500;
    cursor: default;
    color: var(--color-text-primary);
    fill: var(--color-text-primary);
  }
}
